import {FC} from 'react';
import {styled} from 'styled-components';
import {useSearch} from 'wouter';

import {ChampionSummary} from '@shared/api/app_api';

import {UnthemedNavLink} from '@shared-web/components/core/button';

import {ChampionCard} from '@src/components/champion_card';
import {CHAMPIONS} from '@src/lib/champions';
import {Team} from '@src/lib/teams';

interface ChampionOverviewProps {
  info?: ChampionSummary;
  team: Team;
}

export const ChampionOverview: FC<ChampionOverviewProps> = props => {
  const {info, team} = props;
  const queryString = useSearch();

  if (!info) {
    return <EmptyWrapper />;
  }

  const {name, description, ulti, passive, spell1, spell2, spell3} = info;
  const champion = CHAMPIONS.find(c => c.label.toLocaleUpperCase() === name.toLocaleUpperCase());
  if (!champion) {
    return <></>;
  }
  const {image, label} = champion;

  return (
    <WrapperLink to={`/champion/${label}?${queryString}`}>
      <CardWrapper>
        <ChampionCard team={team} champion={{label, image}} />
      </CardWrapper>
      <MardownWrapper>
        <Line title="description">{description}</Line>
        <Line title="ulti">{ulti}</Line>
        <Line title="passive">{passive}</Line>
        <Line title="spell1">{spell1}</Line>
        <Line title="spell2">{spell2}</Line>
        <Line title="spell3">{spell3}</Line>
      </MardownWrapper>
    </WrapperLink>
  );
};

ChampionOverview.displayName = 'ChampionOverview';

const EmptyWrapper = styled.div`
  display: flex;
  min-height: 130px;
  height: 100%;
  background: #ffffff1a;
  border-radius: 8px;
`;
const WrapperLink = styled(UnthemedNavLink)`
  display: flex;
  overflow-x: auto;
  width: auto;
  align-items: flex-start;
`;

const CardWrapper = styled.div`
  display: flex;
  min-height: 130px;
  height: 100%;
  background: #ffffff1a;
  border-radius: 8px;
  width: 130px;
  flex-shrink: 0;
`;

const MardownWrapper = styled.div`
  padding: 4px 16px;
  overflow-y: auto;
`;

const Line = styled.div`
  white-space: nowrap;
  overflow: visible;
  text-overflow: ellipsis;
`;
